import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Config from '../Config';
import Cookies from 'js-cookie';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';

function Versionview() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    let { id } = useParams();

    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    const [version, setVersion] = useState([]);
  
    const getinfo = async (e) => {
        const res = await fetch(`${Config.apiurl}/api/v1/crm/app-version/get-version/${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        });
        if (res.status === 200 ) {
          const data = await res.json();
    
          setVersion(data.data);
    
        } 
        else if(res.status === 401){
          handleUnauthorized();
          getinfo();
        }
        else {
          alert("error");
    
        }
      };

      useEffect(()=>{
        getinfo();
     },[])
  return (
    <div className="container-scroller">
    <Navbar />

    <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
            <div className="content-wrapper">
                <div className='view_page_top'>
                    <Link to="/versions">Version list</Link>
                    <Link to={"/editversion/" + id}>Edit</Link>
                </div>
                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Version View page</h4>

                                <div className='row view_div_row'>
                                    <div className='col-6 '>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6>Android version </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p> {version.androidVersion}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> IOS version </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {version.iOSVersion}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {version?.releaseNotesAndroid?
                                      <div className='col-12'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> Android release notes </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {version.releaseNotesAndroid}</p>
                                            </div>
                                        </div>
                                    </div>
                                    :""}
                                       {version?.releaseNotesIos?
                                      <div className='col-12'>
                                        <div className='view_portion'>
                                            <div className='view_portion_h6'>
                                                <h6> IOS release notes </h6>
                                            </div>
                                            <div className='view_portion_p'>
                                                <p>  {version.releaseNotesIos}</p>
                                            </div>
                                        </div>
                                       
                                    </div>
                                    :""}
                                   
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Versionview
